import { Outlet, useParams } from "react-router-dom";

import type { WhoamiResponseDtoRole } from "@/api/orval/connect.schemas";
import { useGetWhoami } from "@/api/whoami/get-whoami";
import { Forbidden, NotFound } from "@/features/error";

interface RequireRoleProps {
  /** この画面に入れるロール */
  allow: readonly WhoamiResponseDtoRole[];
}

/**
 * ルートに入れるロールを宣言する。
 *
 * ロールが足りないときと、他テナントを開いたときで見せ方を分ける。
 * 後者で「権限がありません」を出すと、テナント ID の実在を推測できてしまう。
 */
export const RequireRole = ({ allow }: RequireRoleProps) => {
  const { role, tenantId } = useGetWhoami();
  const { tenantId: pathTenantId } = useParams<{ tenantId: string }>();

  // ホストは全テナントを横断する。それ以外は自分の所属だけ
  const isOutsideTenant =
    role !== "host" &&
    pathTenantId !== undefined &&
    pathTenantId.toLowerCase() !== tenantId?.toLowerCase();

  if (isOutsideTenant) {
    return <NotFound />;
  }

  if (!allow.includes(role)) {
    return <Forbidden />;
  }

  return <Outlet />;
};
